<template>
  <div class="w-full flex flex-row">
    <portal-target name="headerBreadCrumb"> </portal-target>
    <div class="flex flex-grow justify-between">
      <div class="flex text-lg pl-4 font-bold">
        <span class="pr-4 text-sm md:text-md flex items-center">{{ routeTitle }}</span>
      </div>
    </div>
    <div class="px-4 font-semibold hidden md:flex md:items-center">
      <label class="mr-2">{{ $t('frontend_groovemail_demo_mode') }}</label>
      <InfoIcon
        class="mr-4 cursor-pointer text-grey-600 h-4 w-4 hover:text-primary outline-none"
        v-tooltip="{
          content: $t('frontend_groovemail_demo_mode_tooltip'),
          classes: ['info'],
          targetClasses: ['it-has-a-tooltip'],
          offset: 10,
          delay: {
            show: 200,
            hide: 300,
          },
        }"
      />
      <gd-toggle 
        bgClass="bg-grey-300"
        v-model="toggle"
        @change="changeDemoMode"
      />
    </div>
    <portal-target name="headerContent"> </portal-target>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

// import icons
import InfoIcon from '@/assets/images/icons/new/info_new.svg';

export default {
  name: 'HeaderBar',

  props: ['routeTitle'],

  data() {
    return {
      toggle: this.getIsDemoMode,
    };
  },

  // Used to initialize toggle value from store.
  created() {
    this.toggle = this.getIsDemoMode;
  },

  components: {
    InfoIcon,
  },

  computed: {
    // getters from store
    ...mapGetters('demoMode', ['getIsDemoMode']),
  },

  methods: {
    // actions from store
    ...mapActions('demoMode', ['CHANGE_DEMO_MODE']),

    // Used to toggle demo mode.
    changeDemoMode() {
      this.CHANGE_DEMO_MODE(this.toggle);
    },
  },

};
</script>

<style lang="scss">
  .tooltip {
    display: block !important;
    z-index: 10000;
    
    &-inner {
      background: black;
      color: white;
      border-radius: 16px;
      padding: 5px 10px 4px;
    }
    
    &-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: black;
      z-index: 1;
    }
    
    &[x-placement^='bottom'] {
      margin-top: 5px;
      
      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }
    
    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .5s, visibility .15s;
    }
    
    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .5s;
    }
  }
</style>